export const getDocumentTypeUseFilter = state => state.documentTypeUse.filter
